import React, { Fragment, useEffect, useState } from "react";
import { PaymentContainer } from "../../PaymentHistory/Styles";
import { TableWrapper } from "../../FinalApprover/index";
import { Bold } from "../../RecordingsPage";
import * as XLSX from "xlsx";
import CustomTable from "../../../common/CustomTable/MaterialCustomTable";
import { HyperLink } from "../../MeetingAudioDetails";
import TrackingTimeLine from "./TrackerModal";
import { Footer } from "../../MyCases";
import { PrimaryCTAButton } from "../../../common/Buttons";
import { ButtonContainer } from "../../FinalApprover/Styles";
import BulkTrackingTimeLine from "./TrackerTimeline";
import NoticeService from "../../../../services/NoticeService";
import { useSnackbar } from "notistack";

const ArbitratorRecordings = ({ MTRef, trackingToken, trackingMetaData }) => {
  const [state, setState] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ state: false });
  const [ids, setIds] = useState([]);
  const [current, setCurrent] = useState(1);
  const { enqueueSnackbar } = useSnackbar();
  const [trackingData, setTrackingData] = useState();

  const normalizeKey = (str = "") =>
    str
      .toString()
      .replace(/[^a-zA-Z0-9]/g, "")
      .toLowerCase();

  const findKey = (row, possibleNames) => {
    const rowKeys = Object.keys(row);

    return rowKeys.find((key) =>
      possibleNames.some((name) => normalizeKey(key) === normalizeKey(name)),
    );
  };

  useEffect(() => {
    async function readExcelColumn(s3Url) {
      try {
        setLoading(true);
        const response = await fetch(s3Url);
        const arrayBuffer = await response.arrayBuffer();

        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet);

        const finalList = jsonData
          .map((row, index) => {
            const awbKey = findKey(row, [
              "AWB no",
              "Airway Bill No",
              "Tracking No",
            ]);

            const contractKey = findKey(row, [
              "CONTRACT NUMBER",
              "Contract No",
            ]);

            const folderKey = findKey(row, [
              "Folder Name",
              "Notice Name",
              "Notice Category",
            ]);

            const awb = row[awbKey];
            const contract = row[contractKey];
            const notice_name = row[folderKey];

            if (!awb) return null;

            return {
              id: index + 1,
              trackingId: awb,
              contractNo: contract || "",
              notice_name: notice_name || "",
              created_at: trackingMetaData?.created_at,
              name: trackingMetaData?.uploader_name,
              email: trackingMetaData?.uploader_email,
            };
          })
          .filter(Boolean);
        setState(finalList);
        return finalList;
      } catch (error) {
        console.error("Error reading Excel:", error);
      } finally {
        setLoading(false);
        window.scrollTo(0, 0);
      }
    }

    readExcelColumn(trackingMetaData?.tracking_file); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getTracking(trackingIds, type) {
    try {
      setLoading(true);
      const requestPayload = {
        awb_numbers: trackingIds,
        token: trackingToken,
      };
      if (trackingToken) {
        const response = await NoticeService.getTrackingDetails(requestPayload);
        if (response?.success === "false") {
          enqueueSnackbar(response?.message, {
            variant: "error",
          });
        } else {
          if (type === "single" && response?.shipment?.length) {
            setModal({ state: true, trackingData: response?.shipment });
          } else {
            if (response?.shipment?.length) {
              setCurrent(0);
              setTrackingData(response?.shipment);
            }
          }
        }
      } else {
        enqueueSnackbar("Token not found", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error(
        "Tracking API error:",
        error.response?.data || error.message,
      );
    } finally {
      setLoading(false);
    }
  }

  const columns = [
    {
      field: "notice_name",
      title: "Notice",
      sorting: false,
      render: (rowData) => (
        <Bold style={{ paddingLeft: "12px" }}>{rowData?.notice_name}</Bold>
      ),
      headerStyle: {
        width: 30,
        paddingLeft: "26px",
      },
    },
    {
      field: "name",
      title: "Name",
      sorting: false,
      render: (rowData) => <Bold>{rowData?.name}</Bold>,
    },
    {
      field: "email",
      title: "Email",
      sorting: false,
      render: (rowData) => <Bold>{rowData?.email}</Bold>,
    },
    {
      field: "contractNo",
      title: "Contract No",
      sorting: false,
      render: (rowData) => (
        <HyperLink onClick={() => getTracking(rowData?.trackingId, "single")}>
          {rowData?.contractNo}
        </HyperLink>
      ),
    },
    {
      field: "created_at",
      title: "Created Time",
      sorting: false,
      render: (rowData) => <Bold>{rowData?.created_at}</Bold>,
    },
  ];

  return (
    <Fragment>
      <PaymentContainer className="CreateCase" style={{ overflow: "hidden" }}>
        {current ? (
          <TableWrapper>
            <CustomTable
              selection={true}
              onSelectionChange={(selected) => {
                setIds(selected.map(({ trackingId }) => trackingId));
              }}
              hidePagination={state?.lastPage === 1}
              pageSize={10}
              pluralTitle={"Tracking"}
              singularTitle={"Tracking"}
              placeholderText={"Search"}
              noToolbar={true}
              {...{
                columns,
                page,
                setPage,
              }}
              bodyHeight="100%"
              loading={loading}
              data={state}
              state={state}
            />
            {ids?.length ? (
              <Footer>
                <ButtonContainer>
                  <div className="button-row">
                    <PrimaryCTAButton
                      style={{
                        width: "110px",
                        padding: "10px 10px",
                        marginLeft: "26px",
                        marginTop: 20,
                      }}
                      onClick={() => {
                        getTracking(ids, "multiple");
                      }}
                    >
                      Procced
                    </PrimaryCTAButton>
                  </div>
                </ButtonContainer>
              </Footer>
            ) : null}
          </TableWrapper>
        ) : (
          <BulkTrackingTimeLine {...{ current, setCurrent, trackingData }} />
        )}
      </PaymentContainer>
      {modal?.state && <TrackingTimeLine {...{ modal, setModal }} />}
    </Fragment>
  );
};

export default ArbitratorRecordings;
